import Shortcut from "@/components/shortcut";
import { openEditShortcut } from "@/utils";
import { t } from "i18next";
import { JSX, MouseEvent } from "react";

function ShortcutAddIcon(): JSX.Element {
	const handleClick = (event?: MouseEvent<Element>): void => {
		openEditShortcut({
			bookmark: {
				icon: "",
				itemType: "bookmark",
				title: "",
				url: "",
			},
			event,
		});
	};

	return (
		<Shortcut
			dragId=""
			hasPopup={true}
			isDraggable={false}
			isInDock={false}
			item={{
				icon: "\ue7dc",
				itemType: "action",
				onClick: handleClick,
				title: t("addShortcut"),
				url: "",
			}}
		/>
	);
}

export default ShortcutAddIcon;
